<template>
  <div class="video-tab">
    <div v-if="loading" class="video-tab--loading d-flex justify-content-center align-items-center">
      <b-icon-camera-video-fill></b-icon-camera-video-fill>
    </div>
    <div v-else class="video-tab--content"></div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: "VideoTab",
  data() {
    return {
      loading: true,
    };
  },
};
</script>

<style lang="scss">
.video-tab {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  &--loading {
    min-height: 100%;
    font-size: 180px;
  }
}
</style>